import useSWR from 'swr';
import { SwrReturnType } from '~/models/Api';
import { Status } from '~/models/Status';

const paths = {
  index: '/statuses'
};
type TIndex = () => SwrReturnType<Status[]>;
type ReturnType = {
  index: TIndex;
};
export const useStatuses = (): ReturnType => {
  const index: TIndex = () => {
    const { data, mutate, error } = useSWR<Status[]>(paths.index);
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
